import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {translate} from 'react-i18next';
import {VIEW_MODE} from '../../utils/helpers';
import {getEsi, getMetaSiteId} from '../../utils';
import s from './toolBarStyle.scss';
import Logo from '../partials/Logo';
import InfoButton from '../../containers/InfoButton';

class ToolBar extends Component {
  componentDidMount() {
    window.templateEditUrl = this.props.template.editorUrl;//Adoric need to have this link in the window
  }

  render() {
    const {t, view, template, toggleViewMode, editorClick, experiments = []} = this.props;

    return (
      <div data-hooks="ToolBar-component" className={s.toolBar}>
        <div className={s.elementsGroup}>
          <Logo/>
          <div className={s.elementsGroup}>
            <button
              data-hooks="desktop-view"
              className={`${s.desktopIcon} ${view === VIEW_MODE.DESKTOP ? s.selected : ''}`}
              onClick={() => view === VIEW_MODE.DESKTOP ? '' : toggleViewMode(VIEW_MODE.DESKTOP)}
            ><span className={s.hide}>{t('a11y.desktop.button')}</span></button>
            <hr className={s.hr}/>
            <button
              data-hooks="mobile-view"
              className={`${s.mobileIcon} ${view === VIEW_MODE.MOBILE ? s.selected : ''}`}
              onClick={() => view === VIEW_MODE.MOBILE ? '' : toggleViewMode(VIEW_MODE.MOBILE)}
            ><span className={s.hide}>{t('a11y.mobile.button')}</span></button>
          </div>
        </div>
        <div className={`${s.elementsGroup} ${s.actionMenu}`}>
          <p data-hooks="tool-bar-title" className={s.title}>{t('template.viewer.title')}</p>
          <InfoButton/>
          <a
            className={`${s.button}`}
            data-hooks="editor-link"
            href={template.editorUrl}
            {...experiments.includes('TemplateViewerOpenEditorInSameTab') ? {} : {
              target: '_blank',
            }}
            tabIndex="0"
            onClick={() => editorClick(getEsi(template.editorUrl), 'viewer_top', getMetaSiteId(template.editorUrl))}
          >
            {t('template.viewer.edit.button')}
          </a>
          <label data-hooks="price" className={s.price}>{t('template.viewer.price')} {template.price}</label>
        </div>
      </div>
    );
  }
}

ToolBar.propTypes = {
  t: PropTypes.func,
  view: PropTypes.string.isRequired,
  info: PropTypes.object.isRequired,
  template: PropTypes.object.isRequired,
  toggleViewMode: PropTypes.func.isRequired,
  toggleInfoMode: PropTypes.func.isRequired,
  editorClick: PropTypes.func.isRequired,
  experiments: PropTypes.array,
  originUrl: PropTypes.string,
};

export default translate()(ToolBar);
